import { useContext, useEffect, useState } from 'react'
import { Form, Col, Row, Collapse, Table, Modal } from 'react-bootstrap'
import { Chip, Tooltip } from '@mui/material';
import { isObjectEmpty } from '../utils/utils';
import axios from 'axios';
import { api } from "../services/config"
import { relationsName, ExpType } from "../config/config"
import AddSC from './AddSC';
import { ProjectContext } from '../screens/ProjectScreen';
import { useOutletContext } from 'react-router-dom';
import AddTerm from './AddTerm';

function TermDetails() {
    const {
        setTreeState, setProjectState,
        termData, setTermData,
        setTermClicked,
        headers,
    } = useContext(ProjectContext);

    const [termLinkIsOpen, setTermLinkIsOpen] = useState(true);
    const [classLinksIsOpen, setClassLinksIsOpen] = useState(true)
    const [propertiesIsOpen, setPropertiesIsOpen] = useState(true);
    const [reviewIsOpen, setReviewIsOpen] = useState(false);
    const [addSCIsOpen, setAddSCIsOpen] = useState(false);
    const [duplicateFormIsOpen, setDuplicateFormIsOpen] = useState(false);

    const [semanticClass, setSemanticClass] = useState()

    const { profileState } = useOutletContext();
    const { projectRole: { projectId, role } } = profileState
    const [loading, setLoading] = useState(false)
    const [dblind, setDblind] = useState(true)
    const [avisIsOpen, setAvisIsOpen] = useState(false);

    const termExists = !isObjectEmpty(termData)
    const totalVotes = (termData?.votes?.approve?.count + termData?.votes?.disapprove?.count + termData?.votes?.not_voted?.count) || 0;

    useEffect(() => {
        setSemanticClass();
        if (termData?.vedette_class) {
            fetchSC(termData?.vedette_class)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [termData?.vedette_class])

    useEffect(() => {
        setLoading(true)
        async function fetchReviewTags() {
            await axios.get(`${api.project}${projectId}/`)
                .then(res => {
                    setDblind(res.data.dblind)
                    setLoading(false)
                })
                .catch(
                    function (error) {
                        setLoading(false)
                        return Promise.reject(error)
                    }
                )
        }
        fetchReviewTags()
    }, [projectId])

    async function fetchTerm(id) {
        const { data } = await axios.get(`${api.project}${projectId}/terms/${id}`)
        setTermData(data)
        setTermClicked(true)
    }

    function fetchSC(id) {
        const config = {
            headers
        };
        axios.put(
            `${api.project}${projectId}/sc/`,
            { 'ids': [id] },
            config
        ).then(response => {
            return setSemanticClass(response.data.classes?.[0])
        });
    }

    async function handleDeleteRelation(id) {
        await axios.delete(`${api.project}${projectId}/terms/${termData.id}/relation/${id}/`, { headers });
        updateState(termData.id, id)
    }

    async function updateState(id, relationId) {
        const { data } = await axios.get(`${api.project}${projectId}/terms/${id}`)
        setTermData(data)
        setTermClicked(true)
        setProjectState(projectState => ({ ...projectState, refresh: !projectState?.refresh }))
        let res;
        if (data.vedette_class) {
            res = await axios.put(
                `${api.project}${projectId}/sc/`,
                {
                    'ids': [data.vedette_class],
                },
                { headers }
            )
            if (res.data.classes?.[0].hypernyms)
                setTreeState({
                    item: `relation-${relationId}`,
                    updatedSemantics: res.data.classes[0].hypernyms,
                })

            else
                setTreeState({
                    item: `relation-${relationId}`,
                    updatedSemantics: [0],
                })
        }
    }

    const onChangeValidation = async (e) => {
        setLoading(true)
        const vote = Number(e.target.value)
        const payload = {
            vote,
            ids: [termData.id],
        };
        axios.put(`${api.project}${projectId}/terms/vote/`, payload, { headers })
            .then(async () => {
                await axios.get(`${api.project}${projectId}/terms/${termData.id}`)
                    .then(({ data }) => setTermData(data))
                setProjectState(projectState => ({ ...projectState, refresh: !projectState?.refresh }))
                setLoading(false)
            })
    }

    const onChangeFinalValidation = async (e) => {
        setLoading(true)
        const status = e.target.value === 'true' ? true : e.target.value === 'false' ? false : null
        const term = {
            status,
            ids: [termData.id],
        };
        axios.put(`${api.project}${projectId}/terms/validate/`, term, { headers })
            .then(async () => {
                await axios.get(`${api.project}${projectId}/terms/${termData.id}`)
                    .then(({ data }) => setTermData(data))
                setProjectState(projectState => ({ ...projectState, refresh: !projectState?.refresh }))
                setLoading(false)
            })
    }

    function handleEditSClass() {
        setAddSCIsOpen(true)
    }

    return (
        <div>
            {termExists && <div
                className="term_badge m-3 p-1"
            >
                Terme: {termData.reference}
            </div>}
            {
                termData?.vedette_class && <span
                    className="font-weight-bold mx-3"
                >
                    Terme vedette (classe)
                </span>
            }
            <div className="no-borderRadiusImportant pb-2 mx-3 my-1" style={{ border: '2px solid black', borderRadius: '5px!important' }}>
                <div
                    onClick={() => setTermLinkIsOpen(!termLinkIsOpen)}
                    aria-controls="example-collapse-text"
                    aria-expanded={termLinkIsOpen}
                    className="m-3 c-pointer"
                >
                    <i className={`fas fa-caret-${!termLinkIsOpen ? "right" : "down"} mr-1`}></i>
                    Liens (termes)
                </div>
                <Collapse in={termLinkIsOpen}>
                    <div className="mt-3 mx-5">
                        {
                            termData?.relations && Object.entries(termData?.relations?.reduce((acc, reference) => {
                                if (!acc[reference.relation]) {
                                    acc[reference.relation] = [reference];
                                } else {
                                    acc[reference.relation].push(reference);
                                }
                                return acc;
                            }, {}))
                                .map(([relationType, relations]) => <Row key={relationType}>
                                    <Col md={6} className="pt-1">{relationsName?.[relationType]}</Col>
                                    <Col md={6}>
                                        {relations?.map(relation =>
                                            <Tooltip key={relation.relation_id} title={relation.reference} className="mb-1 mx-1">
                                                <Chip
                                                    label={<EllipsisText>{relation.reference}</EllipsisText>}
                                                    variant="outlined"
                                                    onDelete={() => handleDeleteRelation(relation.relation_id)}
                                                    style={{ maxWidth: "100%" }}
                                                    onClick={() => fetchTerm(relation.id)}
                                                />
                                            </Tooltip>
                                        )}
                                    </Col>
                                </Row>
                                )
                        }
                    </div>
                </Collapse>
            </div>
            {
                semanticClass && <div className="no-borderRadiusImportant pb-2 mx-3 my-1" style={{ border: '2px solid black', borderRadius: '5px!important' }}>
                    <div
                        aria-controls="example-collapse-text"
                        aria-expanded={classLinksIsOpen}
                        className="m-3 d-flex"
                    >
                        <div
                            onClick={() => setClassLinksIsOpen(!classLinksIsOpen)}
                            className="c-pointer"
                        >
                            <i className={`fas fa-caret-${!classLinksIsOpen ? "right" : "down"} mr-1`}></i>
                            Liens (classes)
                        </div>
                        <i
                            className="fas fa-edit ml-auto c-pointer"
                            onClick={handleEditSClass}
                        ></i>
                    </div>
                    <Collapse in={classLinksIsOpen}>
                        <div className="mt-3 mx-5">
                            <Row className="mb-2">
                                <Col md={6}>Hyperonymes</Col>
                                <Col md={6}>
                                    {semanticClass?.hypernyms?.map(item => <Tooltip key={item.id} title={item.term.reference} className="mb-1 mx-1">
                                        <Chip
                                            label={<EllipsisText>{item.term.reference}</EllipsisText>}
                                            style={{ maxWidth: "100%" }}
                                            onClick={() => fetchTerm(item.term.id)}
                                        />
                                    </Tooltip>)}
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col md={6}>Hyponymes</Col>
                                <Col md={6}>
                                    {semanticClass?.hyponyms?.map(item => <Tooltip key={item.id} title={item.term.reference} className="mb-1 mx-1">
                                        <Chip
                                            label={<EllipsisText>{item.term.reference}</EllipsisText>}
                                            style={{ maxWidth: "100%" }}
                                            onClick={() => fetchTerm(item.term.id)}
                                        />
                                    </Tooltip>)}
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col md={6}>Associées</Col>
                                <Col md={6}>
                                    {semanticClass?.associated?.map(item => <Tooltip key={item.id} title={item.term.reference} className="mb-1 mx-1">
                                        <Chip
                                            label={<EllipsisText>{item.term.reference}</EllipsisText>}
                                            style={{ maxWidth: "100%" }}
                                            onClick={() => fetchTerm(item.term.id)}
                                        />
                                    </Tooltip>)}
                                </Col>
                            </Row>
                        </div>
                    </Collapse>
                </div>}
            <div className="no-borderRadiusImportant pb-2 mx-3 mt-1" style={{ border: '2px solid black', borderRadius: '5px!important' }}>
                <div
                    aria-controls="example-collapse-text"
                    aria-expanded={propertiesIsOpen}
                    className="m-3 d-flex"
                >
                    <div
                        onClick={() => setPropertiesIsOpen(!propertiesIsOpen)}
                        className="c-pointer"
                    >
                        <i className={`fas fa-caret-${!propertiesIsOpen ? "right" : "down"} mr-1`}></i>
                        Propriétés
                    </div>
                    <i
                        className={`fas fa-edit ml-auto ${termExists ? "c-pointer" : "c-not-allowed"}`}
                        onClick={() => {
                            if (termExists) {
                                setDuplicateFormIsOpen(true);
                            }
                        }}
                    ></i>
                </div>
                <Collapse in={propertiesIsOpen}>
                    <div className='px-5 pb-2'>
                        <Row>
                            <Col md={6}>Forme</Col>
                            <Col md={6}>{termData?.form?.surfaceForm}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Lemme</Col>
                            <Col md={6}>{termData?.form?.lemma}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>POS Tagging</Col>
                            <Col md={6}>{termData?.form?.posTagging}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Langue</Col>
                            <Col md={6}>{termData?.form?.language}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Analyse syntaxique</Col>
                            <Col md={6}>{termData?.analysis}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Complément</Col>
                            <Col
                                md={6}
                                className="btn btn-link text-left py-0"
                                onClick={() => termData?.expansion?.id && fetchTerm(termData?.expansion?.id)}
                            >{termData?.expansion?.reference}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Position</Col>
                            <Col md={6}>{ExpType?.[termData?.exp_type]}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Tête</Col>
                            <Col
                                md={6}
                                className="btn btn-link text-left py-0"
                                onClick={() => termData?.nth_head?.id && fetchTerm(termData?.nth_head?.id)}
                            >{termData?.nth_head?.reference}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Vedette</Col>
                            <Col md={6}>{termData?.vedette_class ? "Oui" : "Non"}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Label de Classe</Col>
                            <Col md={6}>{termData?.classes?.length > 0 ? "Oui" : "Non"}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Nb de documents</Col>
                            <Col md={6}>{termData?.documents?.n_doc}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Nb de mots</Col>
                            <Col md={6}>{termData?.words}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Nb d'occurrences</Col>
                            <Col md={6}>{termData?.documents?.occurences}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Productivité tête</Col>
                            <Col md={6}>{termData?.head_pdty}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Productivité complément</Col>
                            <Col md={6}>{termData?.exp_pdty}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Pertinence</Col>
                            <Col md={6}>{termData?.form?.relevanceScore}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Producteur</Col>
                            <Col md={6}>{termData?.form?.source?.label}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Validation</Col>
                            <Col md={6}>{termData?.status ? "Oui" : "Non"}</Col>
                        </Row>
                        <Row>
                            <Col md={6}>Format</Col>
                            <Col md={6}>{termData?.form?.source?.engine}</Col>
                        </Row>
                    </div>
                </Collapse>
            </div>
            <div className="no-borderRadiusImportant pb-2 mx-3 my-1" style={{ border: '2px solid black', borderRadius: '5px!important' }}>
                <div
                    onClick={() => setReviewIsOpen(!reviewIsOpen)}
                    aria-controls="example-collapse-text"
                    aria-expanded={reviewIsOpen}
                    className="m-3 c-pointer"
                >
                    <i className={`fas fa-caret-${!reviewIsOpen ? "right" : "down"} mr-1`}></i>
                    Validation
                </div>
                <Collapse in={reviewIsOpen}>
                    <div>
                        <Form className="mt-3 mx-5">
                            {role >= 1 && <Form.Group as={Row} className="mb-3" controlId="">
                                <Form.Label column sm="6" xs="12">
                                    Mon vote
                                </Form.Label>
                                <Col sm="6" xs="12">
                                    {termExists && (
                                        <Form.Control
                                            style={{ width: "85px" }}
                                            size="sm"
                                            as='select'
                                            value={termData?.user_vote || 0}
                                            onChange={onChangeValidation}
                                        >
                                            {!loading && <>
                                                <option value={'1'}>Oui</option>
                                                <option value={'-1'}>Non</option>
                                                {termData?.user_vote === 0 && <option value={'0'}>Non-vu</option>}
                                            </>}
                                        </Form.Control>
                                    )}
                                </Col>
                            </Form.Group>}

                            {!dblind && (
                                <div className='mb-3'>
                                    <Form.Group as={Row} className="mb-1">
                                        <Form.Label column sm="6" xs="12">
                                            Validations des autres utilisateurs
                                        </Form.Label>
                                    </Form.Group>
                                    {termExists && (
                                        <div className='ml-3'>
                                            {/* Summary */}
                                            <div style={{ marginBottom: 8, paddingTop: 7 }}>
                                                Approuvé: {termData?.votes?.approve?.count || 0}/{totalVotes} <br />
                                                Rejeté: {termData?.votes?.disapprove?.count || 0}/{totalVotes} <br />
                                                Non voté: {termData?.votes?.not_voted?.count || 0}/{totalVotes}
                                            </div>

                                            {/* Votes collapse toggle */}
                                            <div
                                                className="c-pointer mb-2"
                                                style={{ fontWeight: "bold", userSelect: "none" }}
                                                onClick={() => setAvisIsOpen(v => !v)}
                                            >
                                                <i className={`fas fa-caret-${!avisIsOpen ? "right" : "down"} mr-1`}></i>
                                                Votes
                                            </div>
                                            <Collapse in={avisIsOpen}>
                                                <div>
                                                    <Table
                                                        responsive
                                                        striped
                                                        bordered
                                                        hover
                                                        size="sm"
                                                        style={{ width: 180 }}
                                                    >
                                                        <tbody>
                                                            {[
                                                                {
                                                                    type: "approve",
                                                                    label: "Oui",
                                                                    voters: termData?.votes?.approve?.voters || [],
                                                                },
                                                                {
                                                                    type: "disapprove",
                                                                    label: "Non",
                                                                    voters: termData?.votes?.disapprove?.voters || [],
                                                                },
                                                                {
                                                                    type: "not_voted",
                                                                    label: "Non-vu",
                                                                    voters: termData?.votes?.not_voted?.voters || [],
                                                                },
                                                            ]
                                                                .flatMap(group =>
                                                                    group.voters.map(voter => (
                                                                        <tr key={`${group.type}-${voter.id}`}>
                                                                            <td>{voter.last_name} {voter.first_name}</td>
                                                                            <td>{group.label}</td>
                                                                        </tr>
                                                                    ))
                                                                )}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Collapse>
                                        </div>
                                    )}
                                </div>
                            )}

                            {role >= 2 && <Form.Group as={Row} className="mb-3" controlId="">
                                <Form.Label column sm="6" xs="12">
                                    Validation finale
                                </Form.Label>
                                <Col sm="6" xs="12">
                                    {termExists && (
                                        <Form.Control
                                            style={{ width: "85px" }}
                                            size="sm"
                                            as='select'
                                            value={termData?.status ?? 'non-vu'}
                                            onChange={onChangeFinalValidation}
                                        >
                                            {!loading && <>
                                                <option value={true}>Oui</option>
                                                <option value={false}>Non</option>
                                                {termData?.status === null && <option value={'non-vu'}>Non-vu</option>}
                                            </>}
                                        </Form.Control>
                                    )}
                                </Col>
                            </Form.Group>}
                        </Form>
                    </div>
                </Collapse>
            </div>

            {duplicateFormIsOpen && <Modal
                show={true}
                onHide={() => {
                    setDuplicateFormIsOpen(false)
                }}
                aria-labelledby="modal-sizes-title-md-2"
                dialogClassName="w-90"
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <AddTerm
                        type="duplicateForm"
                        onClose={() => setDuplicateFormIsOpen(false)}
                    />
                </Modal.Body>
            </Modal>}

            {addSCIsOpen && <Modal
                show={addSCIsOpen}
                onHide={() => setAddSCIsOpen(false)}
                aria-labelledby="add-sc-modal-sizes-title-md"
                dialogClassName="w-90"
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <AddSC
                        semantic={semanticClass}
                        setSemantic={setSemanticClass}
                        setAddSCIsClose={setAddSCIsOpen}
                    />
                </Modal.Body>
            </Modal>}
        </div>
    )
}

const EllipsisText = props => {
    const { children } = props;

    return (
        <div
            style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%"
            }}
        >
            {children}
        </div>
    );
};

export default TermDetails;
